//for create export task api
import { ExportReportRequest, TasksListFilter } from '@dispatch/shared/types';
import { exportReportApi } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';

export function useExportReport<T>(
  responseFn: (response: { success: boolean }) => void
) {
  const { mutate, error, status } = useMutate(
    ['export-report'],
    (data: { request: ExportReportRequest<T> }) =>
      exportReportApi(data.request),
    (response) => responseFn(response as { success: boolean })
  );

  return {
    exportReport: mutate,
    error,
    status,
  };
}
